export default {
    data() {
        return {
            props: {
                expandTrigger: "hover",
                lazy: true,
                lazyLoad: this.cascaderLazyload,
                children: "cities",
                label: "name",
                value: "id",
                multiple: true,
                checkStrictly: true,
                // emitPath: false
            },
            provinceList: [], // 地区列表
            address: ''
        };
    },
    methods: {
        /**
         * 获取地区code和areaLevel
         */
        getAreaIdObj( data ) {
            let arr = data.areaId || []
            let levelOne = [],
                levelTwo = [],
                levelThree = []
            arr.forEach( ( item ) => {
                item.forEach( ( content, index ) => {
                    if ( index == 0 ) levelOne.push( content )
                    if ( index == 1 ) levelTwo.push( content )
                    if ( index == 2 ) levelThree.push( content )
                } )
            } )
            for ( let i = 0; i < levelTwo.length; i++ ) {
                for ( let j = 0; j < levelOne.length; j++ ) {
                    if ( String( levelOne[ j ] ).slice( 0, 2 ) == String( levelTwo[ i ] ).slice( 0, 2 ) ) {
                        levelOne.splice( j, 1 )
                    }
                }
            }
            for ( let i = 0; i < levelThree.length; i++ ) {
                for ( let j = 0; j < levelTwo.length; j++ ) {
                    if ( String( levelTwo[ j ] ).slice( 0, 2 ) == String( levelThree[ i ] ).slice( 0, 2 ) ) {
                        levelTwo.splice( j, 1 )
                    }
                }
            }
            let area1Ids = levelOne.length ? levelOne.join( "," ) : ''
            let area2Ids = levelTwo.length ? levelTwo.join( "," ) : ''
            let area3Ids = levelThree.length ? levelThree.join( "," ) : ''
            return {
                area1Ids,
                area2Ids,
                area3Ids,
            }
        },
        // /**
        //  * 获取地区code和areaLevel
        //  */
        // getAreaIdObj(data) {
        //     this.getAddressName(data)
        //     var areaId = data.areaId
        //     if(data && Object.prototype.toString.call(data.areaId) === "[object Array]") {
        //         areaId = data?.areaId?.length ? data.areaId[data.areaId.length - 1] + '' : undefined
        //     }
        //     if (!areaId) return {}
        //     let areaLevel;
        //     if (/0000$/.test(areaId)) areaLevel = 1 // 省
        //     else if (/00$/.test(areaId)) areaLevel = 2 // 市
        //     else areaLevel = 3 // 区
        //     return {
        //         areaId,
        //         areaLevel,
        //         areaList: data.areaId
        //     }
        // },
        /**
         * 获取省级地址列表
         */
        getAreaTopList() {
            this.axios
                .get( this.getApiUrl( "areaTopList" ) )
                .then( ( res ) => {
                    if ( res.code === 1 ) {
                        this.provinceList = res.data || [];
                    } else {
                        this.$message.warning( res.msg );
                    }
                } )
                .catch( ( err ) => {} );
        },
        /**
         * 动态获取市区
         */
        cascaderLazyload( node, resolve ) {
            const {
                level,
                data
            } = node;
            if ( level >= 3 ) return resolve();
            let id = data ? data.id : "";
            if ( !id ) return;
            let nodes = [];
            this.axios
                .get( this.getApiUrl( "areaList" ) + "?id=" + id )
                .then( ( res ) => {
                    if ( res.code === 1 ) {
                        nodes = res.data || [];
                        nodes.map( ( o ) => {
                            o.leaf = level > 1 ? true : false;
                        } );
                        resolve( nodes );
                    } else {
                        this.$message.warning( res.msg );
                    }
                } )
                .catch( ( err ) => {} );
        },
    },
    mounted() {
        this.getAreaTopList(); // 获取省级地址列表
    },
};